import { getNextMondayMidnight } from './countdownUtils';

const STORAGE_KEY_PREFIX = 'optimizationGenerateMustWait_';
const ATTEMPT_STORAGE_KEY_PREFIX = 'optimizationGenerateAttempted_';

export const setMustWaitForNextUpdate = (brandId) => {
  if (!brandId) return;
  const nextMonday = getNextMondayMidnight();
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${brandId}`, nextMonday.toISOString());
  } catch (e) {
    console.warn('localStorage setItem failed:', e);
  }
};

const clearMustWaitIfExpired = (brandId) => {
  if (!brandId) return false;
  try {
    const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${brandId}`);
    if (!stored) return false;
    const date = new Date(stored);
    if (Date.now() >= date.getTime()) {
      localStorage.removeItem(`${STORAGE_KEY_PREFIX}${brandId}`);
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const getMustWaitForNextUpdate = (brandId) => {
  if (!brandId) return false;
  return clearMustWaitIfExpired(brandId);
};

export const clearMustWait = (brandId) => {
  if (!brandId) return;
  try {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${brandId}`);
  } catch (e) {
    console.warn('localStorage removeItem failed:', e);
  }
};

export const setGenerationAttempted = (brandId) => {
  if (!brandId) return;
  try {
    localStorage.setItem(`${ATTEMPT_STORAGE_KEY_PREFIX}${brandId}`, '1');
  } catch (e) {
    console.warn('localStorage setItem failed:', e);
  }
};

export const hasGenerationAttempted = (brandId) => {
  if (!brandId) return false;
  try {
    return localStorage.getItem(`${ATTEMPT_STORAGE_KEY_PREFIX}${brandId}`) === '1';
  } catch (e) {
    return false;
  }
};

export const clearGenerationAttempted = (brandId) => {
  if (!brandId) return;
  try {
    localStorage.removeItem(`${ATTEMPT_STORAGE_KEY_PREFIX}${brandId}`);
  } catch (e) {
    console.warn('localStorage removeItem failed:', e);
  }
};
